
import React from 'react';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Container from '@material-ui/core/Container';
import { MuiButton, MuiGrid, MuiTypography, MuiDivider, MuiInputBase, MuiFormControl, MuiInputLabel, MuiSelect, MuiMenuItem, MuiFormControlLabel, MuiFormLabel, MuiMoreVertIcon, muiWithStyles, MuiPopover, MuiKeyboardArrowUp, MuiKeyboardArrowDown, MuiCard } from '../../ui/MaterialUIComponents'
import { CssBaseline } from '@material-ui/core';
const useStyles = theme => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
    },
    li: {
      listStyle: 'none',
    },
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
});
class PaymentNotifierComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const classes = this.props.classes;
    return (

      <React.Fragment>
        <CssBaseline />
        {/* Hero unit */}
        <Container maxWidth="sm" component="main" className={classes.heroContent}>
          <MuiTypography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
            {this.props.message} 
      </MuiTypography>
          <MuiTypography variant="h5" align="center" color="textSecondary" component="p">
          {this.props.description} 
      </MuiTypography>
        </Container>
      </React.Fragment>
    );

  }
}

export default muiWithStyles(useStyles)(PaymentNotifierComponent);